import { ChampLibre, ChampLibreAPI } from './champLibre';
import { Document, DocumentAPI } from './document';
import { TypeIntervention } from './typeIntervention';

export class Intervention {
  id: number;
  dateDeRealisation?: Date;
  commentaire?: ChampLibre;
  deambulation?: ChampLibre;
  debit02Repos?: ChampLibre;
  debit02Effort?: ChampLibre;
  duree?: ChampLibre;
  fuites?: ChampLibre;
  iahInitial?: ChampLibre;
  iahResiduel?: ChampLibre;
  obs?: ChampLibre;
  p90_95?: ChampLibre;
  vt?: ChampLibre;
  type?: TypeIntervention;
  compteRendu?: Document;
  rapportMachine?: Document;

  constructor(
    id: number,
    dateDeRealisation?: Date,
    commentaire?: ChampLibre,
    deambulation?: ChampLibre,
    debit02Repos?: ChampLibre,
    debit02Effort?: ChampLibre,
    duree?: ChampLibre,
    fuites?: ChampLibre,
    iahInitial?: ChampLibre,
    iahResiduel?: ChampLibre,
    obs?: ChampLibre,
    p90_95?: ChampLibre,
    vt?: ChampLibre,
    type?: TypeIntervention,
    compteRendu?: Document,
    rapportMachine?: Document,
  ) {
    this.id = id;
    this.dateDeRealisation = dateDeRealisation;
    this.commentaire = commentaire;
    this.deambulation = deambulation;
    this.debit02Repos = debit02Repos;
    this.debit02Effort = debit02Effort;
    this.duree = duree;
    this.fuites = fuites;
    this.iahInitial = iahInitial;
    this.iahResiduel = iahResiduel;
    this.obs = obs;
    this.p90_95 = p90_95;
    this.vt = vt;
    this.type = type;
    this.compteRendu = compteRendu;
    this.rapportMachine = rapportMachine;
  }

  static factory(interventionAPI: InterventionAPI): Intervention {
    var commentaire: ChampLibre = new ChampLibre('COMMENTAIRES');
    var deambulation: ChampLibre | undefined = undefined;
    var debit02Repos: ChampLibre | undefined = undefined;
    var debit02Effort: ChampLibre | undefined = undefined;
    var duree: ChampLibre | undefined = undefined;
    var fuites: ChampLibre | undefined = undefined;
    var iahInitial: ChampLibre | undefined = undefined;
    var iahResiduel: ChampLibre | undefined = undefined;
    var obs: ChampLibre | undefined = undefined;
    var p90_95: ChampLibre | undefined = undefined;
    var vt: ChampLibre | undefined = undefined;
    var libelle: string = '';

    var champLibreList: ChampLibreAPI[] =
      interventionAPI.ChampsLibres.ChampLibre instanceof Array
        ? interventionAPI.ChampsLibres.ChampLibre
        : interventionAPI.ChampsLibres.ChampLibre
          ? [interventionAPI.ChampsLibres.ChampLibre]
          : [];

    champLibreList.forEach((champLibreAPI) => {
      const champLibre = ChampLibre.factory(champLibreAPI);

      switch (champLibre.libelle) {
        case 'COMMENTAIRES':
          champLibre.value =
            commentaire.value && champLibre.value
              ? `${champLibre.value} \n ${commentaire.value}`
              : champLibre.value
                ? typeof champLibre.value == 'number'
                  ? this.correspondanceCommentaire(champLibre.value)
                  : champLibre.value
                : commentaire.value;
          commentaire = champLibre;
          break;

        case 'COMMENT bis champs libres':
          champLibre.value =
            commentaire.value && champLibre.value
              ? `${commentaire.value} \n ${champLibre.value}`
              : champLibre.value
                ? champLibre.value
                : commentaire.value;
          commentaire = champLibre;
          break;

        case 'PRESENSE D\"UN DM DEAMBULATION':
          deambulation = champLibre;
          break;

        case 'DEBIT O2 EFFORT':
          debit02Effort = champLibre;
          break;

        case 'DEBIT O2 REPOS':
          debit02Repos = champLibre;
          break;

        case 'DUREE PRESCRITE - H sur 24H':
          duree = champLibre;
          break;

        case 'FUITES':
          fuites = champLibre;
          typeof fuites.value == 'number'
            ? (fuites.value = this.correspondanceFuite(fuites.value))
            : undefined;
          break;

        case 'IAH INITIAL':
          iahInitial = champLibre;
          break;

        case 'IAH RESIDUEL':
          iahResiduel = champLibre;
          break;

        case 'OBS':
          obs = champLibre;
          break;

        case 'P90/95':
          p90_95 = champLibre;
          break;

        case 'VT - VT CIBLE':
          vt = champLibre;
          break;

        default:
          break;
      }
    });

    switch (interventionAPI.CodeType) {
      case 'PPC A':
        libelle = 'Instal PPC';
        break;
      case 'PPC B':
        libelle = 'Titration 15j';
        break;
      case 'PPC C':
        libelle = 'Titration 30j';
        break;
      case 'PPC D':
        libelle = 'Visite suivi 90j';
        break;
      case 'PPC E':
      case 'PPC VS':
      case 'PPC F':
        libelle = 'Visite suivi PPC';
        break;
      case 'AERO A':
        libelle = 'Instal Aérosol';
        break;
      case 'ASPI A':
        libelle = 'Instal Trach';
        break;
      case 'O2AVFA':
        libelle = 'Instal O2 AVF';
        break;
      case 'O2AVFB':
        libelle = 'Livraison O2 AVF';
        break;
      case 'O2CO A':
      case 'O2CV A':
      case 'O2LQ I':
      case 'O2LQK':
        libelle = 'Instal O2';
        break;
      case 'O2COB':
      case 'O2CO B':
      case 'O2CO D':
        libelle = 'Visite suivi O2';
        break;
      case 'O2LQ P':
        libelle = 'Visite Pharmacien';
        break;
      case 'PPCJ':
        libelle = 'Bilan coaching Non-observant';
        break;
      case 'PPCK':
      case 'PPCM':
        libelle = 'Coaching initial Non-observant';
        break;
      case 'VNI A':
        libelle = 'Instal VNI';
        break;
      case 'VNI B':
        libelle = 'Titration VNI 15j';
        break;
      case 'VNI C':
        libelle = 'Visite suivi VNI';
        break;
      case 'REPCAP':
        libelle = 'Capnographie';
        break;
      case 'REPOXY':
        libelle = 'Oxymétrie';
        break;
      case 'RESPIB':
        libelle = 'Visite/Action additionnelle';
        break;
      case 'O2VPB':
        libelle = 'Visite pharmacien BPDO';
        break;
      case 'O2RA':
        libelle = 'Entretien téléphonique pharmacien BPDO';
        break;
      case 'O2VP':
        libelle = 'Suivi annuel pharmacien BPDO';
        break;
      default:
        libelle = `Suivi (${interventionAPI.CodeType})`;
        break;
    }

    if (interventionAPI.LibelleType == 'PATIENT ABSENT') {
      libelle = `${libelle} • Patient absent`;
    }

    // commentaire.value =
    //   commentaire.value && interventionAPI.Commentaire
    //     ? `${interventionAPI.Commentaire} \n ${commentaire!.value}`
    //     : commentaire.value
    //       ? commentaire.value
    //       : interventionAPI.Commentaire != ''
    //         ? interventionAPI.Commentaire
    //         : undefined;

    var documentAPIList: DocumentAPI[] = interventionAPI.Documents?.DocItv
      ? interventionAPI.Documents?.DocItv instanceof Array
        ? interventionAPI.Documents?.DocItv
        : [interventionAPI.Documents?.DocItv]
      : [];

    const dateFalse = new Date('0001-01-01T00:00:00');
    const dateDeRealisation = new Date(interventionAPI.DateRea);

    return new Intervention(
      interventionAPI.Numero,
      dateDeRealisation.getTime() != dateFalse.getTime()
        ? dateDeRealisation
        : undefined,
      commentaire.value ? commentaire : undefined,
      deambulation,
      debit02Repos,
      debit02Effort,
      duree,
      fuites,
      iahInitial,
      iahResiduel,
      obs,
      p90_95,
      vt,
      new TypeIntervention(interventionAPI.CodeType, libelle),
      documentAPIList.find((doc) =>
        ['15', '30', '90', '18', 'VS', 'IN'].includes(doc.Type),
      )
        ? Document.factory(
            documentAPIList.find((doc) =>
              ['15', '30', '90', '18', 'VS', 'IN'].includes(doc.Type),
            )!,
          )
        : undefined,
      documentAPIList.find((doc) =>
        ['RT', 'OX', 'T1', 'T2', 'T3', 'T4', 'TS', 'AU'].includes(doc.Type),
      )
        ? Document.factory(
            documentAPIList.find((doc) =>
              ['RT', 'OX', 'T1', 'T2', 'T3', 'T4', 'TS', 'AU'].includes(
                doc.Type,
              ),
            )!,
          )
        : undefined,
    );
  }

  private static correspondanceCommentaire(id: number): string {
    switch (id) {
      case 28:
        return 'Patient(e) satisfait(e) et symptômes améliorés';
      case 29:
        return 'Adaptation progressive au traitement';
      case 30:
        return "Difficultés d'adaptation au traitement";
      case 31:
        return "Ajout d'un humidificateur chauffant";
      case 32:
        return "Essai d'un masque facial";
      case 33:
        return "Essai d'un masque narinaire";
      case 367:
        return 'Efficacité du traitement en baisse';
      case 34:
        return 'Patient non observant';
      case 35:
        return 'Demande de désappareillage du patient';
      case 37:
        return 'Observance en baisse en période de maladie';
      case 36:
        return 'Observance en baisse en période de maladie';
      default:
        return '';
    }
  }

  private static correspondanceFuite(id: number): string {
    switch (id) {
      case 19:
        return 'BONNES';
      case 20:
        return 'ACCEPTABLES';
      case 21:
        return 'ANORMALES';
      default:
        return '';
    }
  }
}

export type InterventionAPI = {
  Numero: number;
  DateRea: string;
  CodeType: string;
  LibelleType: string;
  ChampsLibres: {
    ChampLibre?: ChampLibreAPI[] | ChampLibreAPI;
  };
  Commentaire?: string;
  Documents?: {
    DocItv?: DocumentAPI[] | DocumentAPI;
  };
};

export class InterventionList {
  data: Intervention[];
  total: number;
  currentPage?: number;
  lastPage?: number;
  perPage?: number;
  from?: number;
  to?: number;

  constructor(
    data: Intervention[],
    total: number,
    currentPage?: number,
    lastPage?: number,
    perPage?: number,
    from?: number,
    to?: number,
  ) {
    this.data = data;
    this.total = total;
    this.currentPage = currentPage;
    this.lastPage = lastPage;
    this.perPage = perPage;
    this.from = from;
    this.to = to;
  }

  static factory(interventionListAPI: InterventionListAPI): InterventionList {
    var interventionList: Intervention[] = interventionListAPI.data.map(
      (intervention: InterventionAPI) => Intervention.factory(intervention),
    );

    interventionList.sort((a, b) => {
      if (!a.dateDeRealisation && !b.dateDeRealisation) {
        return 0; // Les deux dates sont undefined, donc elles sont égales.
      }
      if (!a.dateDeRealisation) {
        return 1; // a.dateDeRealisation est undefined, donc a vient après b.
      }
      if (!b.dateDeRealisation) {
        return -1; // b.dateDeRealisation est undefined, donc b vient avant a.
      }
      return (
        new Date(b.dateDeRealisation).getTime() -
        new Date(a.dateDeRealisation).getTime()
      );
    });

    return new InterventionList(
      interventionList,
      interventionListAPI.total,
      interventionListAPI.current_page,
      interventionListAPI.last_page,
      interventionListAPI.per_page,
      interventionListAPI.from,
      interventionListAPI.to,
    );
  }
}

export type InterventionListAPI = {
  data: InterventionAPI[];
  total: number;
  current_page?: number;
  last_page?: number;
  per_page?: number;
  from?: number;
  to?: number;
};
